export default {"src":"/hedera/_next/static/media/moon_light.18a2280e.svg","height":16,"width":16};